document.addEventListener('DOMContentLoaded', function () {
  const trigger = document.getElementById('reserveer-trigger');
  const modal = document.getElementById('reserveer-modal');
  const close = document.getElementById('reserveer-modal__close');
  const overlay = document.getElementById('reserveer-modal__overlay');

  if (!trigger || !modal) return;

  trigger.addEventListener('click', function () {
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  });

  close.addEventListener('click', function () {
    modal.style.display = 'none';
    document.body.style.overflow = '';
  });

  overlay.addEventListener('click', function () {
    modal.style.display = 'none';
    document.body.style.overflow = '';
  });
});

